// permission constants
import NON_BOOLEAN_PERMISSIONS from '../constants/nonBooleanPermissions.constant.permission';

const permissionType = ({permissionKey}) =>
  NON_BOOLEAN_PERMISSIONS.includes(permissionKey) ? 'string' : 'boolean';

export default permissionType;
